module.exports = __webpack_public_path__ + "static/media/lic child plan.d82e8cc6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/lic child plan.gif
// module id = 377
// module chunks = 0